export const theme = {
  colors: {
    textDark: '#23262A',
    textWhite: '#FAFAFA',
    textGray: '#BDBDBD',
    textBlue: '#3E4462',

    textTitleDark: '#001833',

    bgBlackLight: '#2A2C36',
    bgBlackDark: '#22252A',
    bgGray: '#D9D9D9',
    bgLightGray: '#ECECEC',
    bgLightGreen: '#EBF3D4',

    bgdarkTheme: '#1E1F28',

    accent: '#8BAA36',

    validateGreen: '#3CBC81',
    validateRed: '#E74A3B',
    validateYellow: '#F6C23E',
  },
  space: [0, 2, 4, 8, 16, 32, 48, 64, 128, 256],

  fontSizes: {
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '24px',
    xxl: '28px',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  effects: {
    mainEffect: '350ms cubic-bezier(0.4, 0, 0.2, 1)',
  },

  borders: {
    none: 'none',
    normal: '1px solid',
  },
  radii: {
    none: '0',
    normal: '4px',
    roundedSquere: '12px',
    round: '50%',
  },
};
